import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from '@tinymce/tinymce-react';

import Input from '../../../components/Input/Input';
import Text from '../../../components/Text/Text';
import { slugify } from '../../../utils/helpers';
import { TINY_API_TOKEN } from '../../../constants/general';
import { editorInit } from '../editorTemplates';

const inputClassName = 'py-[11px] px-[13px] mt-[13px]';
const editorContainerClassName = 'mt-[13px]';

const ArticlesGeneral = ({
  handleChange, handleBlur, errors, touched, values, setFieldValue
}) => {
  const {
    title, url, shortDescription, content
  } = values;

  return (
    <div>
      <div>
        <Text text="Title:" muted required />
        <Input
          type="text"
          name="title"
          value={title}
          placeholder="Article title"
          onBlur={handleBlur}
          onChange={(data) => {
            const { target: { value } } = data;
            handleChange(data);
            setFieldValue('url', slugify(value));
          }}
          errorText={touched.title && errors?.title}
          inputStyle={inputClassName}
        />
      </div>
      <div>
        <Text text="Url:" muted required />
        <Input
          type="text"
          name="url"
          value={url}
          placeholder="Article url"
          onBlur={handleBlur}
          onChange={handleChange}
          errorText={touched.url && errors?.url}
          inputStyle={inputClassName}
        />
      </div>
      <div>
        <Text text="Short description:" muted required />
        <Input
          type="text"
          name="shortDescription"
          value={shortDescription}
          placeholder="Short description"
          onBlur={handleBlur}
          onChange={handleChange}
          errorText={touched.shortDescription && errors?.shortDescription}
          inputStyle={inputClassName}
          multiline
        />
      </div>
      <div>
        <Text text="Content:" muted required />
        <div className={editorContainerClassName}>
          <Editor
            value={content}
            apiKey={TINY_API_TOKEN}
            onEditorChange={(editorContent) => setFieldValue('content', editorContent)}
            init={editorInit}
          />
        </div>
      </div>
    </div>
  );
};

ArticlesGeneral.propTypes = {
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  errors: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    shortDescription: PropTypes.string,
    content: PropTypes.string,
  }),
  touched: PropTypes.shape({
    title: PropTypes.bool,
    url: PropTypes.bool,
    shortDescription: PropTypes.bool,
    content: PropTypes.bool,
  }),
  values: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    shortDescription: PropTypes.string,
    content: PropTypes.string,
  }),
};

ArticlesGeneral.defaultProps = {
  handleChange: () => {},
  handleBlur: () => {},
  setFieldValue: () => {},
  errors: null,
  touched: null,
  values: {}
};

export default ArticlesGeneral;
